import { Component } from 'react'
import * as styles from 'components/features/socialFeed/FeedfilterPopup/FeedFilterYourPopup.styl'
import { BlockCorners } from 'interfaces/component'
import { SidebarPopup } from 'components/features/pfm/SidebarPopup/SidebarPopup'
import { SidebarPopupBackButton } from 'components/features/pfm/SidebarPopup/SidebarPopupBackButton'
import { SidebarPopupHeader } from 'components/features/pfm/SidebarPopup/SidebarPopupHeader'
import { PopupOverview } from 'components/features/pfm/SidebarPopup/PopupOverview'
import { SidebarPopupFooter } from 'components/features/pfm/SidebarPopup/SidebarPopupFooter'
import Button from 'components/features/pfm/Button/Button'
import { PeerDefinition } from 'components/features/pfm/PeerDefinition/PeerDefinition'
import { Peergroup } from 'interfaces/peergroups'
import { preparePeerDefinitionProps } from 'helpers/peergroupsHelpers'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'
import { MemberAvatar } from 'components/features/socialFeed/Avatar/MemberAvatar'


export type FeedFilterYourPopupStateProps = {
  hidePopupTimeoutId: number | null
  username: string | null
  peergroup: Peergroup
}

export type FeedFilterYourPopupDispatchProps = {
  onViewPosts: () => void
  onCreateNickname: () => void
  onHidePopup: () => void
  onRegisterHideTimeout: (timeoutId: number) => void
}

export type FeedFilterYourPopupOwnProps = {
  corners: BlockCorners
  onBackButtonClick?: () => void
}

type FeedFilterYourPopupProps =
  & FeedFilterYourPopupStateProps
  & FeedFilterYourPopupDispatchProps
  & FeedFilterYourPopupOwnProps

export class FeedFilterYourPopup extends Component<FeedFilterYourPopupProps> {
  render () {
    const {
      corners,
      onHidePopup,
      hidePopupTimeoutId, onRegisterHideTimeout,
      username,
    } = this.props

    return (
      <SidebarPopup
        corners={ corners }
        stretchHeight
        hidePopupTimeoutId={ hidePopupTimeoutId }
        onRegisterHideTimeout={ onRegisterHideTimeout }
        onHidePopup={ onHidePopup }
      >
        { username ? this.renderRegistered(username) : this.renderUnregistered() }
      </SidebarPopup>
    )
  }

  private renderRegistered (username: string) {
    const {
      onBackButtonClick,
      peergroup,
      onViewPosts,
      onHidePopup,
    } = this.props

    return (
      <>
        <SidebarPopupHeader
          title={
            <div className={ styles.title }>
              <div className={ styles.avatar }>
                <MemberAvatar />
              </div>
              <div className={ styles.nickname }>
                { username }
              </div>
            </div>
          }
          left={
            !!onBackButtonClick && (
              <SidebarPopupBackButton onClick={ onBackButtonClick } />
            )
          }
        />
        <PeerDefinition
          isRange
          { ...preparePeerDefinitionProps(peergroup) }
        />
        <footer className={ styles.footer }>
          <div className={ styles.buttonWrapper }>
            <Button theme='blue' size='small' fullWidth onClick={ onViewPosts }>
              View Your Posts
            </Button>
          </div>
          <p>
            If anything seems incorrect you can edit
            your profile on your
            { ' ' }
            <NavigationLink
              onClick={ onHidePopup }
              className={ styles.link }
              to='settings'
            >
              settings
            </NavigationLink>
            { ' ' }
            page.
          </p>
        </footer>
      </>
    )
  }

  private renderUnregistered () {
    const { onBackButtonClick } = this.props

    return (
      <>
        <SidebarPopupHeader
          title='Your Posts'
          left={
            !!onBackButtonClick && (
              <SidebarPopupBackButton onClick={ onBackButtonClick } />
            )
          }
        />
        <PopupOverview
          imageSrc='/images/emoji/pen.png'
          title={
            <>
              Looks like you haven't
              <br />
              created any posts yet.
            </>
          }
          subtitle='Choose a nickname to begin posting.'
        />
        <SidebarPopupFooter>
          <Button theme='blue' size='small' fullWidth onClick={ this.handleCreateNickname }>
            Choose a Nickname
          </Button>
        </SidebarPopupFooter>
      </>
    )
  }

  private handleCreateNickname = () => {
    const {
      onHidePopup, onCreateNickname,
    } = this.props

    onHidePopup()
    onCreateNickname()
  }
}
